import { caching } from '@/common/cache.dict.js';
import { eventDates, NEW_YEAR_ID } from '@/common/events/common/event.settings.js';


const forcedActive = false;

export const isEventDate = () => !!getCurrentEvent();

function _getCurrentEvent() {
    if (forcedActive)
        return eventDates[0];

    const currentDate = new Date();

    for (const event of eventDates) {
        const dateStart = new Date(event.date.start + ' ' + currentDate.getFullYear());
        const dateEnd = new Date(event.date.end + ' ' + currentDate.getFullYear());

        // если событие новый год, учесть изменение в году
        if (event.id === NEW_YEAR_ID && currentDate.getMonth() === 0)
            dateStart.setFullYear(dateStart.getFullYear() - 1);
        if (event.id === NEW_YEAR_ID && currentDate.getMonth() === 11)
            dateEnd.setFullYear(dateEnd.getFullYear() + 1);

        if (currentDate >= dateStart && currentDate <= dateEnd)
            return event;
    }

    return null;
}

export const getCurrentEvent = caching(_getCurrentEvent);
